import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, Redirect } from 'react-router';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { IRegion } from 'src/Interfaces/WellInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { allOrNoneSelected } from 'src/UtilityFunctions/SelectAllOrNone';
import { IEBPExpenseType } from '../../../../Interfaces/TestInterface';
import ButtonRow from '../../../ButtonRow';
import { EInput } from '../../../EInput';



@inject('stores')
@observer
class AdminExpenseTypeDetails extends React.Component {

    public props: any;
    public expenseType: IEBPExpenseType = new IEBPExpenseType();
    public expenseTypeDisposer: any;
    public adminStore: AdminStore;
    public MessageStore: any;
    private UserStore: UserStore;

    public state = {
        expenseType: this.expenseType,
        expenseTypeId: '',
        isDirty: false,
        redirect: false,
        regions: [] as IRegion[],
        selectedRegions: [] as boolean[],
    };

    constructor(props: any) {
        super(props);

        this.adminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = this.props.stores.UserStore;
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeRadio = this.handleChangeRadio.bind(this);
        this.handleSaveExpenseType = this.handleSaveExpenseType.bind(this);
        this.removeExpenseType = this.removeExpenseType.bind(this);
    }

    public handleRegionSelect = (index: number) => (event: any) => {
        const selectedRegions = this.state.selectedRegions;
        selectedRegions[index] = !selectedRegions[index];
        this.setState({selectedRegions});
    }

    public renderRegionCheckBox = (region: IRegion, index: number) => {
        const checked = this.state.selectedRegions;
        return (
            <FormGroup key={region.id}>
                <Label check={true}>
                    <Input
                        type="checkbox"
                        checked={checked[index]}
                        onChange={this.handleRegionSelect(index)}
                        />
                    {region.name}
                </Label>
            </FormGroup>
        );
    }

    public componentDidMount() {
        this.createDisposers();
        this.adminStore.getRegions()
        .then(regions => {
            this.setState({
                expenseTypeId: this.props.match.params.id,
                regions,
                selectedCategorys: [],
            }, () => {
                if ( this.state.expenseTypeId !== 'new' ) {
                    this.adminStore.getExpenseType(this.props.match.params.id);
                }
            });
        });
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.expenseTypeDisposer = intercept(this.adminStore, 'expenseType', (change: any) => {
            this.setState({
                expenseType: change.newValue
            }, () => {
                this.setSelectedRegions();
            });

            return change;
        });
    }

    public clearDisposers() {
        this.expenseTypeDisposer();
    }

    private setSelectedRegions = () => {
        const expenseType = this.state.expenseType;
        const regions = this.state.regions;
        const selectedRegions = this.state.selectedRegions;
        regions.forEach((region, index) => {
            if (expenseType.regions.some(reg => reg.id === region.id))
            {
                selectedRegions[index] = true;
            } else {
                selectedRegions[index] = false;
            }
        });
        this.setState({selectedRegions});
    }

    public handleChange(event: any) {
        const expenseType = this.state.expenseType;
        expenseType[event.target.name] = event.target.value;
        this.setState({
            expenseType,
            isDirty: true,
        });
    }

    public handleChangeRadio(event: any) {
        const expenseType = this.state.expenseType;
        expenseType.isRental = !expenseType.isRental;
        this.setState({
            expenseType,
            isDirty: true,
        });
    }

    public handleChangeTaxable = (event: any) => {
        const expenseType = this.state.expenseType;
        expenseType.isTaxable = !expenseType.isTaxable;
        this.setState({
            expenseType,
            isDirty: true,
        });
    }

    public handleChangeDispatchable = (event: any) => {
        const expenseType = this.state.expenseType;
        expenseType.dispatchable = !expenseType.dispatchable;
        this.setState({
            expenseType,
            isDirty: true,
        });
    }

    public handleSaveExpenseType() {
        const expense = this.state.expenseType;
        const regions = this.state.regions;
        const selectedRegions = this.state.selectedRegions;
        expense.regions = [];
        regions.forEach((region, index) => {
            if(selectedRegions[index] === true)
            {
                expense.regions.push(region);
            }
        });
        this.adminStore.saveExpenseType(expense)
            .then(
                (data: any) => {
                    if (data) {
                        this.setState({
                            redirect: true
                        });
    
                        this.MessageStore.addMessage(
                            'Changes have been saved',
                            'success'
                        );
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public removeExpenseType() {
        const areYouSure = confirm(`Deleting this EBP Item will not affect any Wells/Well Tests that this EBP Item exists on, however, it will remove it from all Price Lists.\n\nAre you sure you want to remove EBP Item: ${this.state.expenseType.name}?\n\nPress OK to delete.`);
        if (areYouSure) {
            this.adminStore.deleteExpenseType(this.state.expenseType)
                .then(
                    (data: any) => {
                        this.setState({
                            redirect: true
                        });

                        this.MessageStore.addMessage(
                            'EBP Item Successfully Deleted',
                            'success'
                        );
                    }
                );
        }
    }

    private selectAllOrNone = (value: boolean) => () => {
        const regions = this.state.regions;
        const selectedRegions = new Array(regions.length).fill(value);
        this.setState({selectedRegions});
    }
    private allOrNoneSelected = (value: boolean) => {
        return allOrNoneSelected(value, 'regions', 'selectedRegions', this.state);
    }
    private renderSelectionButons = () => {
        return (
            <div style={{marginBottom: '1rem'}}>
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelected(true)}
                    onClick={this.selectAllOrNone(true)}
                >
                    All
                </Button>
                {' '}
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelected(false)}
                    onClick={this.selectAllOrNone(false)}
                >
                    None
                </Button>
            </div>
        );
    }

    public render() {
        return(
            this.state.redirect ? (
                <Redirect to="/admin/products" />
            ) : (
                <div>
                    <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                    <Row className="header">
                        <Col md="12">
                            {this.state.expenseTypeId === 'new' ? (
                                <h2 className="float-left">Add New EBP</h2>
                            ) : (
                                <h2 className="float-left">EBP Detail for {this.state.expenseType.name}</h2>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup className="required">
                                <Label>Name</Label>
                                <EInput
                                    type="text"
                                    name="name"
                                    required={true}
                                    value={this.state.expenseType.name}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>ERP ID</Label>
                                <EInput
                                    type="text"
                                    name="erpId"
                                    value={this.state.expenseType.erpId}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Cost</Label>
                                <EInput
                                    type="text"
                                    name="cost"
                                    required={true}
                                    value={this.state.expenseType.cost}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Price</Label>
                                <EInput
                                    type="text"
                                    name="retailPrice"
                                    required={true}
                                    value={this.state.expenseType.retailPrice}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Weight</Label>
                                <EInput
                                    type="text"
                                    name="weight"
                                    required={true}
                                    value={this.state.expenseType.weight}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    <EInput
                                        type="checkbox"
                                        name="isTaxable"
                                        value={this.state.expenseType.isTaxable}
                                        checked={this.state.expenseType.isTaxable}
                                        onChange={this.handleChangeTaxable}
                                    />Is Taxable
                                </Label>
                            </FormGroup>
                            <FormGroup check={true}>
                                <Label check={true}>
                                    <Input
                                        type="radio"
                                        name="isRental"
                                        checked={Boolean(this.state.expenseType.isRental)}
                                        onChange={this.handleChangeRadio}
                                    />{'  '}
                                    Rental
                                </Label>
                            </FormGroup>
                            <FormGroup check={true}>
                                <Label check={true}>
                                    <Input
                                        type="radio"
                                        name="isRental"
                                        checked={Boolean(!this.state.expenseType.isRental)}
                                        onChange={this.handleChangeRadio}
                                    />{'  '}
                                    Service
                                </Label>
                            </FormGroup>
                            <FormGroup>    
                                <Label>
                                    <Input
                                        type="checkbox"
                                        name="dispatchable"
                                        checked={this.state.expenseType.dispatchable}
                                        onChange={this.handleChangeDispatchable}
                                    />Dispatchable
                                </Label>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            
                            <h4>Regions</h4>
                            {this.renderSelectionButons()}
                            <div style={{maxHeight: '65vh', overflowY: 'scroll'}}>
                                    {
                                        this.state.regions.map((region, index) => {
                                            return this.renderRegionCheckBox(region, index);
                                        })
                                    }
                            </div>
                    </Col>
                    </Row>
                    <ButtonRow>
                        {
                            this.UserStore.hasPermission('Permissions.Admin.Inventory.Delete') &&
                            <Button color="danger" onClick={this.removeExpenseType} >Delete EBP Item</Button>
                        }
                    {
                        (this.state.expenseType.id === '' ?
                        this.UserStore.hasPermission('Permissions.Admin.Inventory.Create')
                        :
                        this.UserStore.hasPermission('Permissions.Admin.Inventory.Update'))
                        &&
                        <Button color="primary" onClick={this.handleSaveExpenseType}>Save EBP Item</Button>
                    }
                    </ButtonRow>
                </div>
            )
        );
    }
}

export default AdminExpenseTypeDetails;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/ExpenseTypes/AdminExpenseTypeDetails.tsx